import React, { useState, useEffect } from 'react';
import SFCustomTable from './custom/SFCustomTable.js';
import { IconButton, Dialog, DialogTitle, DialogContent, DialogActions, TextField, Accordion, AccordionSummary, AccordionDetails } from '@mui/material';
import { MdEdit } from 'react-icons/md';
import { FiTrash2 } from 'react-icons/fi';
import { Button, Cell, Grid } from 'react-md';
import ApiRequestService from './ApiRequestService.js';
import { NotificationManager } from 'react-notifications';
import { MdRefresh } from "react-icons/md";
import ReactTooltip from 'react-tooltip';
import DeleteDialog from '../pages/DeleteDialog.js';
import { PiCaretDown } from "react-icons/pi";
import { Card } from "react-md";


const WhitelistTable = () => {
    const columns = [
        {
            name: <div className='sf-data-table-header'>ID</div>,
            selector: row => row.id,
            sortable: true,
        },
        {
            name: <div className='sf-data-table-header'>Email ID</div>,
            selector: row => row.email_id,
            sortable: true,
        },
        {
            name: <div className='sf-data-table-header'>Actions</div>,
            sortable: false,
            cell: (row, rowIndex) => {
                return (
                    <div>
                        <IconButton onClick={() => {
                            setEmailID(row.email_id);
                            setShowDeleteDialog(true);
                        }}>
                            <FiTrash2 color='#bb0000' />
                        </IconButton>
                    </div>
                );
            },
        },
    ];

    const [whitelistedEmails, setWhitelistedEmails] = useState([]);
    const [loading, setLoading] = useState(false);
    const [emailID, setEmailID] = useState("");
    const [showDialog, setShowDialog] = useState(false);

    const [showDeleteDialog, setShowDeleteDialog] = useState(false);

    useEffect(() => {
        getWhitelistedEmails()
    }, []);

    const getWhitelistedEmails = () => {
        setLoading(true);
        ApiRequestService({
            method: 'get',
            url: '/getWhitelistedEmailIDs',
        }).then(res => {
            if (res && res.message) {
                NotificationManager.error(res.message, "Error")
                return
            }

            setWhitelistedEmails(res?.data?.data ?? []);

        }).finally(() => {
            setLoading(false);
        })
    }

    const validateEmail = (value) => {
        return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value);
    };

    const handleAddEmail = () => {
        let isEmailValid = validateEmail(emailID)
        if (!isEmailValid) {
            NotificationManager.error("", "Invalid Email Address")
            return
        }

        // check if this email already exists
        const isExists = whitelistedEmails.some(item => item.email_id === emailID);
        if (isExists) {
            NotificationManager.error("", "Email Already Exists");
            return;
        }

        setLoading(true);
        ApiRequestService({
            method: 'post',
            url: '/addWhitelistEmail',
            data: {
                email: emailID,
            }
        }).then(res => {
            if (res && res.message) {
                NotificationManager.error(res.message, "Error")
                return
            }
            let tempEmailIDArr = [...whitelistedEmails];
            tempEmailIDArr.push({
                id: tempEmailIDArr.length + 1,
                email_id: emailID,
            });
            setWhitelistedEmails(tempEmailIDArr);
            setShowDialog(false);
            setEmailID("");
            NotificationManager.success("", "Email has been successfully whitelisted")
        }).finally(() => {
            setLoading(false);

        })
    }

    const handleDeleteEmail = () => {
        setLoading(true);
        ApiRequestService({
            method: 'post',
            url: '/deleteWhitelistEmail',
            data: {
                email: emailID,
            }
        }).then(res => {
            if (res && res.message) {
                NotificationManager.error(res.message, "Error")
                return
            }
            let tempEmailIDArr = [...whitelistedEmails];
            let index = tempEmailIDArr.findIndex(data => data.email_id === emailID);
            if (index > -1) {
                tempEmailIDArr.splice(index, 1)
            }
            setWhitelistedEmails(tempEmailIDArr);
            setShowDeleteDialog(false);
            setEmailID("");
            NotificationManager.success("", "Email has been successfully deleted")
        }).finally(() => {
            setLoading(false);
        })
    }

    return (
        <div>
            <Card style={{ marginLeft: "0px", marginBottom: '8px' }}>
                <Accordion sx={{ boxShadow: 'none' }}>
                    <AccordionSummary
                        expandIcon={<PiCaretDown fontSize={24} />}
                    >
                        <div className='semester-title' style={{ display: 'flex', alignItems: 'center' }}>
                            <h3>Whitelisted Emails ({whitelistedEmails.length}) </h3>
                            <ReactTooltip id={"refresh-whitelistemails"} type='light' className='tool-tip'>
                                <span>Refresh whitelisted email ids</span>
                            </ReactTooltip>
                            {/* <IconButton
                            data-tip data-for="refresh-whitelistemails"
                            onClick={(e) => {
                                e.stopPropagation();
                                getWhitelistedEmails()
                            }}>
                            <MdRefresh />
                        </IconButton> */}
                        </div>
                    </AccordionSummary>
                    <AccordionDetails>
                        <SFCustomTable
                            loading={loading}
                            columns={columns}
                            selectableRows={false}
                            data={whitelistedEmails}
                            topPagination={false}
                            bottomPagination={true}
                            showSearch={true}
                            searchPlaceholder="Search by email"
                            searchByFields={['email_id']}
                            rowsPerPage={10}
                            btn={
                                <Button style={{ marginLeft: '8px' }} primary raised onClick={() => {
                                    setEmailID("");
                                    setShowDialog(true);
                                }}>
                                    Add Email to be Whitelisted
                                </Button>
                            }
                        />
                    </AccordionDetails>
                </Accordion>
            </Card>

            {/* Add dialog */}
            <Dialog open={showDialog} maxWidth="sm" fullWidth>
                <DialogTitle>
                    Add New Email
                </DialogTitle>
                <DialogContent>
                    <TextField
                        fullWidth
                        placeholder='Enter email address'
                        id="email-id"
                        value={emailID}
                        onChange={event => {
                            setEmailID(event.target.value);
                        }}
                    />
                </DialogContent>
                <DialogActions>
                    <Button primary flat onClick={() => setShowDialog(false)}>
                        Cancel
                    </Button>
                    <Button primary raised onClick={() => {
                        handleAddEmail()
                    }}>
                        Add
                    </Button>
                </DialogActions>
            </Dialog>

            {/* Delete dialog */}
            <DeleteDialog
                showDialog={showDeleteDialog}
                title={"Delete Email"}
                description={`Are you sure you want to delete "${emailID}"?`}
                onCancel={() => {
                    setEmailID("");
                    setShowDeleteDialog(false);
                }}
                onDelete={() => {
                    handleDeleteEmail();
                }}
            />
        </div>
    );
};

export default WhitelistTable;
